import { useState, useEffect, useRef } from "react";
import {
  faBuilding,
  faCubes,
  faFileLines,
  faGear,
  faHouse,
  faListCheck,
  faMessage,
  faSprayCan,
  faTicket,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { myscrm } from "assets/images/images";
import { useNavigate } from "react-router-dom";
import SubMenu from "./subMenu/subMenu";

const SuperAdminSidebar = ({ active }) => {
  const navigate = useNavigate();
  const [reports, setReports] = useState(false);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setReports(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const reportRef = useRef();
  useOutsideAlerter(reportRef);
  const data = [
    {
      icon: <FontAwesomeIcon icon={faHouse} style={{ color: "#fff" }} />,
      title: "Dashboard",
      navigate: "/backend/dashboard",
    },
    {
      icon: <FontAwesomeIcon icon={faBuilding} style={{ color: "#fff" }} />,
      title: "Companies",
      navigate: "/backend/company",
    },
    {
      icon: <FontAwesomeIcon icon={faFileLines} style={{ color: "#fff" }} />,
      title: "Invoices",
      navigate: "/backend/invoices",
    },
    {
      icon: <FontAwesomeIcon icon={faTicket} style={{ color: "#fff" }} />,
      title: "Tickets",
      navigate: "/backend/tickets",
    },
    {
      icon: <FontAwesomeIcon icon={faMessage} style={{ color: "#fff" }} />,
      title: "Message",
      navigate: "/backend/chat",
    },
    {
      icon: <FontAwesomeIcon icon={faListCheck} style={{ color: "#fff" }} />,
      title: "Reports",
      navigate: "",
    },
    {
      icon: <FontAwesomeIcon icon={faSprayCan} style={{ color: "#fff" }} />,
      title: "Frontend Settings",
      navigate: "",
    },
    {
      icon: <FontAwesomeIcon icon={faGear} style={{ color: "#fff" }} />,
      title: "App Settings",
      navigate: "/backend/app-settings",
    },
    {
      icon: (
        <svg
          className="cursor-pointer w-[17px]"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.4505 6.23702V2.89954H4.77377V3.62991H3.348V4.20378H4.63133V4.93278H3.348V6.23702H2.4505ZM2.3053 0H11.5016C12.1127 0.0010888 12.6984 0.242558 13.1305 0.671518C13.5626 1.10048 13.8058 1.68196 13.8069 2.2886V7.05114C13.8047 7.65707 13.561 8.2375 13.129 8.66557C12.697 9.09364 12.1119 9.33454 11.5016 9.33563H6.28667L2.78793 12.3258C2.72987 12.3745 2.65868 12.4053 2.58318 12.4143C2.50768 12.4233 2.43118 12.4101 2.36317 12.3763C2.29516 12.3425 2.23861 12.2897 2.20055 12.2244C2.16249 12.159 2.14457 12.084 2.14903 12.0086L2.33572 9.33563H2.3053C1.69495 9.33454 1.10985 9.09364 0.677877 8.66557C0.245906 8.2375 0.0021919 7.65707 0 7.05114L0 2.2886C0.00109674 1.68196 0.244328 1.10048 0.676417 0.671518C1.10851 0.242558 1.69423 0.0010888 2.3053 0ZM15.1663 3.38416C15.6802 3.48421 16.1435 3.75754 16.4777 4.15786C16.8119 4.55818 16.9964 5.06087 17 5.58078V10.6879C16.9982 11.2818 16.7596 11.8509 16.3365 12.2707C15.9133 12.6905 15.34 12.927 14.7417 12.9285H14.6587L14.8441 15.6509C14.8462 15.7155 14.8297 15.7794 14.7964 15.835C14.7631 15.8905 14.7144 15.9354 14.6562 15.9643C14.5979 15.9933 14.5326 16.005 14.4678 15.9981C14.4031 15.9912 14.3417 15.966 14.2909 15.9255L10.7714 12.8406H5.29098L7.57 10.5396H13.251C13.7586 10.5378 14.2449 10.3367 14.6038 9.98024C14.9626 9.62375 15.1648 9.1408 15.1663 8.63683V3.53518C15.1663 3.48439 15.1663 3.43359 15.1663 3.38416ZM11.5071 0.775681H2.3053C1.90178 0.779286 1.51592 0.94049 1.23123 1.22441C0.946535 1.50832 0.785906 1.89211 0.784105 2.29272V7.05114C0.787736 7.45174 0.950116 7.8348 1.2361 8.11743C1.52209 8.40007 1.90868 8.55953 2.31221 8.56132H2.78516C2.83606 8.5648 2.88576 8.57823 2.93141 8.60084C2.97706 8.62344 3.01776 8.65479 3.05117 8.69306C3.08458 8.73133 3.11005 8.77578 3.1261 8.82385C3.14215 8.87193 3.14848 8.92268 3.14472 8.97318L2.98707 11.1437L5.87318 8.67252C5.90953 8.63668 5.95272 8.60839 6.0002 8.5893C6.04769 8.57021 6.09853 8.5607 6.14976 8.56132H11.5002C11.9025 8.55774 12.2874 8.39748 12.5719 8.11504C12.8564 7.8326 13.0178 7.45056 13.0214 7.05114V2.2886C13.0178 1.88919 12.8564 1.50715 12.5719 1.22471C12.2874 0.942266 11.9025 0.782009 11.5002 0.778427L11.5071 0.775681ZM5.56064 6.24114H4.59261L5.66989 2.89954H6.89653L7.98625 6.23702H7.01822L6.29635 3.81937H6.27007L5.5482 6.23702L5.56064 6.24114ZM5.37948 4.92454H7.19108V5.60275H5.36704V4.92042L5.37948 4.92454ZM9.4383 5.0028H10.1297L10.3718 5.31856L10.7977 5.80594L11.3509 6.49238H10.5612L10.1685 6.02972L9.90295 5.64394L9.42585 5.00554L9.4383 5.0028ZM11.3619 4.57308C11.3724 4.8993 11.2981 5.22271 11.1462 5.51214C11.014 5.75682 10.8126 5.95774 10.5667 6.09012C10.3153 6.21962 10.0362 6.28722 9.75291 6.28722C9.46964 6.28722 9.19052 6.21962 8.93907 6.09012C8.6938 5.95621 8.49298 5.75446 8.36102 5.50939C8.21065 5.22096 8.13733 4.89906 8.14805 4.57446C8.13699 4.24851 8.21031 3.92519 8.36102 3.6354C8.493 3.3907 8.69385 3.1894 8.93907 3.05604C9.19066 2.92699 9.46972 2.85964 9.75291 2.85964C10.0361 2.85964 10.3152 2.92699 10.5667 3.05604C10.8123 3.18938 11.0136 3.39065 11.1462 3.6354C11.2985 3.9247 11.3728 4.2482 11.3619 4.57446V4.57308ZM10.4381 4.57308C10.4428 4.40133 10.4161 4.23015 10.3593 4.06786C10.3167 3.94235 10.2367 3.8327 10.1297 3.75347C10.0169 3.68434 9.8869 3.64772 9.75429 3.64772C9.62168 3.64772 9.49168 3.68434 9.37883 3.75347C9.27191 3.83298 9.19147 3.9425 9.14789 4.06786C9.09223 4.23041 9.06601 4.40146 9.07045 4.57308C9.06195 4.74443 9.08395 4.91592 9.13544 5.07968C9.17904 5.20466 9.25951 5.31373 9.36639 5.3927C9.47896 5.4626 9.60907 5.49966 9.74184 5.49966C9.87462 5.49966 10.0047 5.4626 10.1173 5.3927C10.2242 5.31402 10.3043 5.20481 10.3469 5.07968C10.4036 4.91737 10.4303 4.7462 10.4257 4.57446L10.4381 4.57308Z"
            fill={"#fff"}
            fill-opacity="1"
          />
        </svg>
      ),
      title: "Admin FAQ",
      navigate: "/backend/admin-faq",
    },
    {
      icon: <FontAwesomeIcon icon={faCubes} style={{ color: "#fff" }} />,
      title: "Packages",
      navigate: "/backend/packages",
    },
  ];
  return (
    <>
      {reports && (
        <div ref={reportRef} className="relative -right-52">
          <div
            style={{ backgroundColor: "white" }}
            className="absolute h-screen drop-shadow-lg border-x-2 z-[15] border-[rgba(0,0,0,.1)] w-64 px-2 py-12"
          >
            <SubMenu />
          </div>
        </div>
      )}
      <div className="h-screen bg-[#1e293b] pb-6 w-64 border-r-[1px] border-[(rgba(0,0,0,.2))] flex flex-col justify-between">
        <div>
          <div className="h-[9vh] desktop:h-[7vh] bigDesktop:h-[5vh] flex items-center bg-[#dadbdf]">
            <div className="pl-6">
              <img src={myscrm} alt="" />
            </div>
          </div>
          {data.map((e, i) => {
            return (
              <div
                key={i}
                className={`py-4 ${
                  active === e.title && "bg-[#324154]"
                } flex items-center pl-7 hover:bg-[#324154] cursor-pointer`}
                onClick={() => {
                  e.title === "Reports"
                    ? setReports(!reports)
                    : setReports(false);
                  e.navigate && navigate(e.navigate);
                }}
              >
                <div className="w-10">{e.icon}</div>
                <p className="text-sm text-[#fff] ml-1">{e.title}</p>
              </div>
            );
          })}
          <div
            onClick={() => {
              localStorage.removeItem("User");
              navigate("/");
            }}
            style={{
              borderRadius: 5,
            }}
            className="bg-[#324154] cursor-pointer text-white flex items-center justify-center !text-sm p-0 font-medium h-10 mx-5 mt-3"
          >
            Logout
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperAdminSidebar;
